import React from "react";
import ReactEcharts from "echarts-for-react";
import { postureIconChipStyle, postureIconStyle } from "./iconStyles";

const ORANGE_COLORS = {
  primary: '#FF5B00',
  dark: '#e85a28',
  darker: '#d14d1f',
  light: '#ff8c61',
  lighter: '#ffb399',
};

const SeverityBreakdownChart = ({ analyticsData = [] }) => {
  const isDarkMode = document.documentElement.getAttribute('data-layout-mode') === 'dark';
  const textColor = isDarkMode ? '#a6b0cf' : '#858d98';
  
  if (!analyticsData || analyticsData.length === 0) {
    return (
      <div className="text-center py-5">
        <span className="d-inline-flex align-items-center justify-content-center mb-3" style={postureIconChipStyle("var(--vz-primary)")}>
          <i className="ri-pie-chart-line" style={postureIconStyle("var(--vz-primary)")}></i>
        </span>
        <p className="text-muted">No severity data available</p>
      </div>
    );
  }
  
  const severityData = analyticsData.map(item => ({
    value: item.count,
    name: item.severity
  }));
  
  // Color mapping with severity-based colors
  const colorMap = {
    Critical: '#dc2626',
    High: '#ea580c',
    Medium: '#eab308',
    Low: '#16a34a'
  };
  
  const totalThreats = severityData.reduce((sum, item) => sum + item.value, 0);
  
  const option = {
    tooltip: {
      trigger: 'item',
      backgroundColor: isDarkMode ? 'rgba(30, 41, 59, 0.9)' : 'rgba(255, 255, 255, 0.9)',
      borderColor: isDarkMode ? '#3e4c5f' : '#e5e7eb',
      textStyle: { color: textColor, fontSize: 12 },
      formatter: params => {
        const percentage = ((params.value / totalThreats) * 100).toFixed(1);
        return `<strong>${params.name}</strong><br/>${params.value} threats (${percentage}%)`;
      }
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      top: 'middle',
      textStyle: { 
        color: textColor,
        fontSize: 12
      },
      itemGap: 12,
      formatter: name => {
        const item = severityData.find(d => d.name === name);
        const percentage = item ? ((item.value / totalThreats) * 100).toFixed(1) : 0;
        return `${name} (${percentage}%)`;
      }
    },
    color: severityData.map(item => colorMap[item.name] || ORANGE_COLORS.primary),
    series: [
      {
        name: 'Severity Levels',
        type: 'pie',
        radius: ['45%', '70%'],
        center: ['60%', '50%'],
        data: severityData,
        label: {
          color: textColor,
          fontSize: 11,
          fontWeight: 'bold',
          formatter: params => {
            const percentage = ((params.value / totalThreats) * 100).toFixed(1);
            return `${params.value}\n${percentage}%`;
          }
        },
        labelLine: {
          lineStyle: { 
            color: isDarkMode ? 'rgba(166, 176, 207, 0.3)' : 'rgba(133, 141, 152, 0.3)',
            width: 1
          },
          length: 15,
          length2: 10
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 15,
            shadowOffsetX: 0,
            shadowColor: isDarkMode ? 'rgba(255, 107, 53, 0.5)' : 'rgba(0, 0, 0, 0.3)'
          },
          label: {
            show: true,
            fontSize: 13,
            fontWeight: 'bold'
          }
        }
      }
    ],
    textStyle: { fontFamily: 'Poppins, sans-serif' }
  };
  
  return <ReactEcharts style={{ height: "310px" }} option={option} />;
};

export default SeverityBreakdownChart;
